import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import apiService from "../services/api.service";

const EventRegistrationLink = ({ event }) => {
  const [busy, setBusy] = useState(false);
  const [url, setUrl] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const copyLink = async () => {
    setBusy(true);
    setError("");
    setMessage("");
    setUrl("");
    try {
      const response = await apiService.getEventRegistrationLink(event.id);
      const link = response.data?.url;
      if (!link) throw new Error("Missing registration link");
      try {
        if (!navigator.clipboard?.writeText) throw new Error("Clipboard unavailable");
        await navigator.clipboard.writeText(link);
        setMessage("Link copiato.");
      } catch {
        setUrl(link);
        setMessage("Seleziona e copia il link.");
      }
    } catch {
      setError("Impossibile ottenere il link di iscrizione.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <Button size="sm" variant="outline-primary" disabled={busy}
        onClick={copyLink} aria-label={`Copia link iscrizione ${event.name}`}>
        {busy ? "Caricamento..." : "Copia link iscrizione"}
      </Button>
      {message && <small className="d-block mt-1" role="status">{message}</small>}
      {url && <Form.Control className="mt-1" size="sm" readOnly value={url}
        aria-label={`Link iscrizione ${event.name}`} onFocus={(e) => e.target.select()} />}
      {error && <small className="d-block mt-1 text-danger" role="alert">{error}</small>}
    </div>
  );
};

export default EventRegistrationLink;
